import { Box, Slider, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { ToolManager } from '~/engine/tool/ToolManager';
import { LineDeformTool } from '~/engine/tool/tools/contouring-tools/LineDeformTool';
import { lineDeformOptionsState } from '~/state/atoms/toolsAtoms';

const MIN_SPREAD_PERCENT = 1;
const MAX_SPREAD_PERCENT = 100;

export default function LineDeformToolOptions() {
    const [deformOptions, setDeformOptions] = useRecoilState(
        lineDeformOptionsState
    );

    const handleSetSpread = (_: Event, newValue: number | number[]) => {
        const percent = Array.isArray(newValue) ? newValue[0] : newValue;
        if (percent < MIN_SPREAD_PERCENT || percent > MAX_SPREAD_PERCENT) {
            return;
        }
        setDeformOptions((options) => ({
            ...options,
            spreadPercent: percent,
        }));
        const activeTool = ToolManager.getActiveTool();
        if (activeTool instanceof LineDeformTool) {
            activeTool.spreadPercent = percent;
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mx: -0.5,
            }}
        >
            <Typography
                variant="body2"
                fontSize={11}
                color="rgba(255, 255, 255, 0.6)"
                sx={{ flexShrink: 0 }}
            >
                Contour %
            </Typography>
            <Slider
                value={deformOptions.spreadPercent}
                onChange={handleSetSpread}
                step={1}
                min={MIN_SPREAD_PERCENT}
                max={MAX_SPREAD_PERCENT}
                size="small"
                sx={{
                    minWidth: 100,
                    height: 14,
                    '& .MuiSlider-rail': {
                        height: 14,
                        borderRadius: 100,
                        opacity: 1,
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                    '& .MuiSlider-track': {
                        height: 14,
                        borderRadius: 100,
                        border: 'none',
                        backgroundColor: 'primary.main',
                    },
                    '& .MuiSlider-thumb': {
                        height: 12,
                        width: 12,
                        backgroundColor: '#fff',
                        border: 'none',
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
                        zIndex: 1,
                        '&:hover, &.Mui-active, &.Mui-focusVisible': {
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.5)',
                        },
                    },
                }}
            />
            <Typography
                variant="body2"
                fontSize={11}
                color="rgba(255, 255, 255, 0.85)"
                sx={{
                    flexShrink: 0,
                    minWidth: 30,
                    textAlign: 'right',
                    fontVariantNumeric: 'tabular-nums',
                }}
            >
                {deformOptions.spreadPercent} %
            </Typography>
        </Box>
    );
}
